import { css } from "@emotion/css";
import { BasicButton, Link } from "@certn/cascadia";
import {
  DialogTrigger,
  Popover,
  PopoverHeading,
  PopoverContent,
  PopoverActions,
} from "@certn/cascadia-react";
import { slugify } from "@certn/utils";
import { useTranslation } from "react-i18next";
import { Fragment } from "react";
import { CheckCardSelectProps } from "./CheckCardSelect";
import { useCanAccessSettings } from "../../../permissions/Permissions";

export function SelectFieldDescription(
  props: Pick<CheckCardSelectProps, "selectFieldDescription">
) {
  const { selectFieldDescription } = props;
  const { t } = useTranslation();
  const canAccessSettings = useCanAccessSettings();

  if (!selectFieldDescription) {
    return null;
  }

  const popoverHeading = selectFieldDescription[0]?.[1];
  const popoverContent = selectFieldDescription[0]?.[2];
  if (popoverHeading == null || popoverContent == null) {
    return null;
  }

  const actionText = selectFieldDescription[1]?.[0];
  const actionLink = selectFieldDescription[1]?.[1];

  return (
    <div className={styles.popover}>
      <DialogTrigger>
        <Link testID="whats-this-link" textStyle="form/body-secondary-link">
          {t("What's this?")}
        </Link>
        <Popover placement="top right">
          <Fragment key=".0">
            <PopoverHeading>{popoverHeading}</PopoverHeading>
            <div className={styles.popoverContent}>
              <PopoverContent>{popoverContent}</PopoverContent>
            </div>
            {actionText && actionLink && canAccessSettings && (
              <PopoverActions>
                <BasicButton
                  size="small"
                  rightIcon="open_in_new"
                  onPress={() => {
                    window.open(`${window.location.origin}${actionLink}`);
                  }}
                  testID={slugify(actionText)}
                >
                  {actionText}
                </BasicButton>
              </PopoverActions>
            )}
          </Fragment>
        </Popover>
      </DialogTrigger>
    </div>
  );
}

const styles = {
  popover: css({
    display: "flex",
    gap: "var(--space-1)",
    alignItems: "center",
  }),
  popoverContent: css({
    display: "flex",
    gap: "var(--space-2)",
    flexDirection: "column",
    paddingTop: "var(--space-2)",
    paddingBottom: "var(--space-2)",
  }),
};
